import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/** Titles the document for the utility's portal, or the neutral portal with no utility. */
export function useDocumentTitle(orgName: string | null): void {
  const { t } = useTranslation("customer");
  const org = orgName?.trim();
  const title = org ? t("shell.documentTitle", { org }) : t("shell.documentTitleNeutral");
  useEffect(() => {
    document.title = title;
  }, [title]);
}
